import { Input } from '@chakra-ui/react'

import { FormItem } from 'components'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'

export default function DefaultValueText({ formMethods, question }: DefaultValueCommonProps) {
  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <FormItem label="Valor inicial">
      <Input {...formMethods.register('default_value')} />
    </FormItem>
  )
}
